import { motion } from "framer-motion";

export default function FocusPull({ children, delay = 0, amount = 14, y = 24, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y, scale: 1.03, filter: `blur(${amount}px)` }}
      whileInView={{ opacity: 1, y: 0, scale: 1, filter: "blur(0px)" }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
